import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../mock';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Accueil', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'À Propos', href: '/a-propos' },
    { name: 'Projets', href: '/projets' },
    { name: 'Contact', href: '/contact' }
  ];

  const isActivePage = (href) => {
    if (href === '/' && location.pathname === '/') return true;
    if (href !== '/' && location.pathname.startsWith(href)) return true;
    return false;
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      {/* Top bar with contact info */}
      <div className="bg-slate-800 text-white py-1.5 lg:py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center text-xs lg:text-sm">
            {/* Contact info - always visible */}
            <div className="flex items-center space-x-3 lg:space-x-6">
              <a href="tel:+22527223498015" className="flex items-center space-x-1 lg:space-x-2 hover:text-orange-400 transition-colors">
                <Phone className="w-3 h-3 lg:w-4 lg:h-4" />
                <span className="hidden sm:inline">+225 27 22 34 98 15</span>
                <span className="sm:hidden">Appeler</span>
              </a>
              <a href="mailto:contact@set-g.com" className="flex items-center space-x-1 lg:space-x-2 hover:text-orange-400 transition-colors">
                <Mail className="w-3 h-3 lg:w-4 lg:h-4" />
                <span className="hidden sm:inline">contact@set-g.com</span>
                <span className="sm:hidden">Email</span>
              </a>
            </div>
            {/* Experience text - hidden on mobile, full text on desktop */}
            <div className="hidden lg:block text-sm text-slate-300">
              {companyInfo.experience} d'excellence - Gérant: 25+ ans d'expérience (Afrique et Moyen-Orient)
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3 lg:py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 lg:space-x-3 hover:opacity-90 transition-opacity flex-shrink-0">
            <img 
              src={companyInfo.logo} 
              alt={`${companyInfo.name} - ${companyInfo.fullName} - Logo officiel entreprise télécommunications Côte d'Ivoire`}
              title={companyInfo.name}
              className="h-10 lg:h-12 w-auto"
            />
            <div className="hidden md:block">
              <h1 className="text-lg lg:text-xl font-bold text-slate-800">{companyInfo.name}</h1>
              <p className="text-xs text-slate-600 hidden xl:block">{companyInfo.fullName}</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-4 xl:space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`font-medium transition-all duration-200 px-2 xl:px-3 py-2 rounded-lg text-sm xl:text-base whitespace-nowrap ${
                  isActivePage(item.href)
                    ? 'text-orange-600 bg-orange-50'
                    : 'text-slate-700 hover:text-orange-600 hover:bg-orange-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block flex-shrink-0">
            <Button 
              asChild
              className="bg-orange-600 hover:bg-orange-700 text-white px-4 xl:px-6 py-2 rounded-lg font-medium transition-all duration-200 shadow-md hover:shadow-lg text-sm xl:text-base"
            >
              <Link to="/contact">
                <span className="hidden xl:inline">Demande de Devis</span>
                <span className="xl:hidden">Devis</span>
              </Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-slate-700"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-100 py-4">
            <nav className="space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`block font-medium transition-colors duration-200 px-3 py-2 rounded-lg ${
                    isActivePage(item.href)
                      ? 'text-orange-600 bg-orange-50'
                      : 'text-slate-700 hover:text-orange-600 hover:bg-orange-50'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Button 
                asChild
                className="w-full bg-orange-600 hover:bg-orange-700 text-white mt-4"
                onClick={() => setIsMenuOpen(false)}
              >
                <Link to="/contact">
                  Demande de Devis
                </Link>
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;